import {
  Square,
  Heading,
  Stack,
  Row,
  Column,
  Button,
} from '@grubhubprod/gh-cookbook-react/dist';
import React from 'react';
import { useForm } from 'react-hook-form/dist/index.ie11';
import { useHistory, useParams } from 'react-router-dom';
import { Input } from 'src/components/Input/Input';
import { pushError, pushSuccess } from 'src/utilities/notifications';
import { sdk } from 'src/utilities/sdk';
import PageSection from 'src/components/enterprise/layout/PageSection';
import { RouterButtonLink } from 'src/components/RouterLink/RouterButtonLink';

interface FormFields {
  departmentName: string;
}

export default function EnterpriseDepartmentCreate(): JSX.Element {
  const { corpid } = useParams<{ corpid: string }>();
  const { push } = useHistory();

  const { register, handleSubmit, formState } = useForm<FormFields>({
    mode: 'onChange',
  });

  const { isValid } = formState;

  async function addNewDepartment({ departmentName }: FormFields) {
    try {
      await sdk.http.post(`/corp-admin/${corpid}/departments`, {
        owner_id: corpid,
        name: departmentName,
      });

      pushSuccess(`${departmentName} has been added to your departments`);
      push(`/corporate/enterprise/${corpid}/departments`);
    } catch (error) {
      pushError(
        `${departmentName} was not added to your departments. Try again.`
      );
    }
  }

  return (
    <Square inset="md">
      <PageSection>
        <Stack y="sm">
          <Heading variant="h4">Add a New Department</Heading>
        </Stack>
        <form>
          <Stack y="sm">
            <Row gutter={0}>
              <Column gutter={0} tablet={6} desktop={5}>
                <Input
                  id="departmentName"
                  name="departmentName"
                  ariaLabel="Department name"
                  placeholder="Department name"
                  maxLength={50}
                  ref={register({
                    maxLength: 50,
                    required: true,
                  })}
                />
              </Column>
            </Row>
          </Stack>
          <Row gutter={8}>
            <Column gutter={8} tablet={4} desktop={3}>
              <Button
                variant="primary"
                block
                buttonSize="medium"
                disabled={!isValid}
                onClick={handleSubmit(addNewDepartment)}
              >
                Add new
              </Button>
            </Column>
            <Column
              gutter={8}
              tablet={4}
              desktop={3}
              style={{ textAlign: 'center' }}
            >
              <RouterButtonLink
                href={`/corporate/enterprise/${corpid}/departments`}
                buttonSize="medium"
                buttonVariant="secondary"
                useBlockButton
              >
                Cancel
              </RouterButtonLink>
            </Column>
          </Row>
        </form>
      </PageSection>
    </Square>
  );
}
